<template>
  <v-layout>
    <v-container grid-list-md>
      <v-card>
        <v-card-title class="greyk lighten-4k">
          <h3>Students</h3>
        </v-card-title>

        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm6>
              <v-autocomplete
                label="Class"
                :items="myclasses"
                item-text="name"
                item-value="id"
                v-model="selected_class"
              />
            </v-flex>
            <v-flex xs12 sm6></v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12>
              <v-card class="elevation-6">
                <v-card-title>
                  <h4 style="margin:10px">list</h4>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-data-table
                    :headers="students_headers"
                    :items="c_students"
                    class="elevation-0"
                    :search="search"
                    :disable-pagination="true"
                  >
                    <template v-slot:items="props">
                      <td>{{ props.index + 1 }}</td>
                      <td>
                        <img
                          :src="'/images/avatars/'+props.item.s_bio.avatar"
                          alt="profile pic"
                          class="mt-2"
                          style="width:50px;height:50px;border-radius:50%"
                          v-if="props.item.s_bio.avatar"
                        />
                        <img
                          src="../../../../img/user.jpg"
                          alt="profile pic"
                          class="mt-2"
                          style="width:50px;height:50px;border-radius:50%"
                          v-else
                        />
                      </td>
                      <td class="text-xs-center">{{ props.item.s_bio.name }}</td>
                      <td class="text-xs-center">{{ props.item.rollno }}</td>
                      <td class="text-xs-center">{{ props.item.s_bio.email }}</td>
                      <td class="text-xs-center">{{ props.item.s_guardian?props.item.s_guardian.name +' ('+props.item.s_guardian.phone+')' : 'N/A' }}</td>

                    </template>
                  </v-data-table>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn class="success">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-container>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  layout: "teacher",
  data() {
    return {
      date: new Date().toISOString().substr(0, 10),
      modal: false,
      c_students: [],
      status: 1,
      search: "",
      selected_class: {},
      students_headers: [
        {
          text: "SN",
          align: "center",
          sortable: false,
          value: "level"
        },
        {
          text: "Image",
          align: "center",
          sortable: false,
          value: "student"
        },
        {
          text: "Name",
          align: "center",
          sortable: true,
          value: "s_bio.name"
        },
        {
          text: "Std. ID",
          align: "center",
          sortable: true,
          value: "rollno"
        },
        {
          text: "Email",
          align: "center",
          sortable: true,
          value: "email"
        },
        {
          text: "Guardian",
          align: "center",
          sortable: true,
          value: "s_guardian.name"
        },
      ],

    };
  },
  methods: {
    showScores() {
      console.log(this.c_students);
    }
  },
  mounted() {
    this.$store.dispatch("classes/getMyClasses");
  },
  computed: {
    ...mapGetters({
      myclasses: "classes/MYCLASSES",
      errors: "classes/CLASS_ERROR",
      loading: "classes/CLASS_LOADING"
    })
  },
  watch: {
    selected_class(val) {
      var data = this.myclasses.find(x => x.id === val);
      // console.log(data)
      this.c_students = data.students ? data.students : [];
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/teacher/students/students.vue